import { app_system_administrator_RowClass } from '../../dbschema/app_system_administrator.model';
import { BaseContainerModel } from '../base-container.model';

export class SysAdminModel extends BaseContainerModel {
  app_system_administrator: app_system_administrator_RowClass = new app_system_administrator_RowClass();
}
